var n = (u, o, t) => new Promise((i, a) => {
  var y = (e) => {
    try {
      r(t.next(e));
    } catch (s) {
      a(s);
    }
  }, l = (e) => {
    try {
      r(t.throw(e));
    } catch (s) {
      a(s);
    }
  }, r = (e) => e.done ? i(e.value) : Promise.resolve(e.value).then(y, l);
  r((t = t.apply(u, o)).next());
});
import { u as m, a as c } from "./query-client-DZ5Df1It.js";
import { r as f } from "./define-element-XpjsV6s1.js";
function S() {
  return m(), c({
    queryKey: ["states"],
    queryFn: () => n(null, null, function* () {
      return yield f("states");
    })
  });
}
export {
  S as u
};
